'use client';
import React, {useState, useEffect} from 'react';
import Typewriter from "@/components/Typewritter/Typewritter";
import {TEXT_CONSTANTS} from "@/constants/apiConstants";

interface WelcomeMessageProps {
    name: string;
    projectName?: string;
    textColor?: string;
}

export default function WelcomeMessage({name, projectName, textColor}: WelcomeMessageProps) {
    return (
        <Label name={name || ''} projectName={projectName} textColor={textColor}/>
    );
}

function Label({name, projectName, textColor}: WelcomeMessageProps) {
    const [randomMessage, setRandomMessage] = useState<string>('');
    const [isReady, setIsReady] = useState<boolean>(false);

    useEffect(() => {
        if (projectName) {
            setRandomMessage(`How can I help you with ${projectName}?`);
            setIsReady(true);
        } else {
            const randomIndex = Math.floor(Math.random() * TEXT_CONSTANTS.MAIN_PAGE.length);
            setRandomMessage(TEXT_CONSTANTS.MAIN_PAGE[randomIndex] || TEXT_CONSTANTS.MAIN_PAGE[0]);
            setIsReady(true);
        }
    }, [projectName]);

    if (!randomMessage || !isReady) return null;

    return (
        <div className="w-full min-h-[60px] md:min-h-[87px]">
            <div className="text-center">
                <h1
                    className="font-medium text-[#0e153e] text-3xl md:text-[41.4px] leading-normal md:leading-[45.5px] block mb-1 md:mb-2">
                    Hi there{name ? `, ${name.split(' ').slice(0, 2).join(' ')}` : '!'}
                </h1>
                <h1
                    className={`font-bold text-2xl md:text-[41.4px] leading-normal md:leading-[43.4px] block ${!textColor ? 'text-PrBlue' : ''}`}
                    style={textColor ? {color: `#${textColor}`} : undefined}>
                    <Typewriter speed={50} text={randomMessage}/>
                </h1>
            </div>
        </div>
    );
}